var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggCrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.555 18.35c-3.79 0-6.873-2.974-6.873-6.63 0-1.809.762-4.221 1.942-6.144C6.038 3.27 7.789 2 9.555 2s3.517 1.27 4.932 3.576c1.18 1.924 1.942 4.336 1.942 6.145 0 3.655-3.084 6.63-6.874 6.63z",
    fill: "#FFFBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.555 18.35c-3.79 0-6.873-2.974-6.873-6.63 0-1.809.762-4.221 1.942-6.144C6.038 3.27 7.789 2 9.555 2c-4.344 2.654-5.997 9.625-3.622 12.577C8.31 17.529 15 15.727 16.43 11.721c0 3.655-3.084 6.63-6.874 6.63z",
    fill: "#ECDAD2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.479 7.502c.82 0 1.533-.421 1.901-1.041.17-.287-.704-2.971-1.901-2.971-1.198 0-2.168.898-2.168 2.006 0 1.107.97 2.006 2.168 2.006zM4.305 9.673c1.273 0 2.305-.954 2.305-2.132 0-1.177-1.032-2.132-2.305-2.132-.628 1.428-2.007 3.333-1.535 3.723.408.337.945.541 1.535.541zm11.187 5.478c-.423-1.297-1.725-2.242-3.265-2.242-1.883 0-3.409 1.412-3.409 3.154 0 1.043.548 1.968 1.392 2.542 1.234-.206 5.376-3.165 5.282-3.454z",
    fill: "#FF6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.492 15.151c-.163-.5-.282-.768-.67-1.13C13.17 15.9 11.444 16.313 8.83 16c-.06 1.186.566 2.051 1.38 2.605 1.234-.206 5.376-3.165 5.282-3.454z",
    fill: "#EB5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.714 7.134c.247-.134.537-.456.666-.673.17-.287-.704-2.971-1.901-2.971-.45 0-.87.127-1.216.344 1.171 1.074 1.61 1.893 2.45 3.3z",
    fill: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.305 9.673c.223 0 .439-.03.643-.084.206-1.293.537-2.36 1.052-3.496-.417-.385-1.06-.684-1.695-.684-.628 1.428-2.007 3.333-1.535 3.723.408.337.945.541 1.535.541z",
    fill: "#EB5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.555 17.725c3.45 0 6.249-2.7 6.249-6.004 0-1.687-.727-3.988-1.85-5.818-1.312-2.138-2.883-3.278-4.399-3.278-1.515 0-3.087 1.14-4.399 3.278-1.122 1.83-1.85 4.13-1.85 5.818 0 3.305 2.8 6.004 6.25 6.004zm0 1.25c-4.13 0-7.498-3.249-7.498-7.254 0-1.933.797-4.456 2.034-6.472C5.609 2.775 7.54 1.375 9.555 1.375c2.016 0 3.947 1.4 5.465 3.874 1.237 2.017 2.034 4.54 2.034 6.472 0 4.005-3.369 7.254-7.499 7.254z",
    fill: "#31323D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#31323D",
    strokeWidth: 0.88,
    d: "M9.826 2L9 3.49l.762.883L8.5 6.249l1.888 2.374L8.833 11m1.653-2.257l1.37 1.695"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggCrack);
export default __webpack_public_path__ + "static/media/eggCrack.aee3d6d6bc20bdd6dde0f28e5780c22b.svg";
export { ForwardRef as ReactComponent };